let attedenceStatus = [
    { key: "Present", value: "present" },
    { key: "Unauthorized Absence", value: "unauthorizedAbsence" },
    { key: "Withdrawn", value: "withdrawn" },
    { key: "Authorized Absence", value: "authorizedAbsence" },
    { key: "Unmark", value: "unmark" },
    { key: "Late", value: "late" }
]

export const config = attedenceStatus;